import React from 'react';
import {Grid} from "@mui/material";
import EditToggleButton from "./EditToggleButton";
import BookingDetails from "./BookingDetails";
import classNames from "classnames";

const containerSx = {
  paddingBottom: '0.71em',
  gap: '1.43rem',
} as const;

interface BookingDetailsFieldToggleProps {
  title: string;
  open: boolean;
  value: string | number;
  onChange: (value: boolean, event: React.MouseEvent) => void;
  className?: string;
  toggleButtonClassName?: string;
  disableToggle?: boolean;
  children?: React.ReactNode;
}

const BookingDetailsFieldToggle = (props: BookingDetailsFieldToggleProps) => {
  const {title, open, onChange, value, className, toggleButtonClassName, disableToggle, children} = props;

  return (
    <Grid item container justifyContent={'space-between'} alignItems={'flex-end'} wrap={'nowrap'}
          className={classNames(className)} sx={containerSx}>
      {
        open ? <Grid item xs>{children}</Grid> : <Grid item xs>
          <BookingDetails title={title} value={value}/>
        </Grid>
      }
      {!disableToggle && <EditToggleButton open={open} onClick={onChange} className={toggleButtonClassName}/>}
    </Grid>
  );
};

export default BookingDetailsFieldToggle;
